import { ROLE_STATUS } from '../../../utils/constants/commonValues';
import moment from 'moment';

function Role(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

Role.prototype = Object.assign(Role.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.roleDetails &&
            tableData.roleDetails.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { currentPage, totalRecord } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: currentPage,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalRecord,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            roleUpdatedBy,
            roleUpdatedByName,
            roleUpdateionDate,
            roleCreatedBy,
            roleCreatedByName,
            roleCreationDate,
            resourceDetail,
            roleId,
            roleStatus,
            roleName,
            comment,
        } = row;
        return {
            lastUpdatedBy: roleUpdatedBy,
            lastUpdatedByName: roleUpdatedByName,
            lastUpdatedDate: this.convertDate(roleUpdateionDate),
            roleCreatedBy,
            roleCreatedByName,
            roleCreationDate: this.convertDate(roleCreationDate),
            resourceDetail,
            roleId,
            roleStatus: this.getStatus(roleStatus),
            roleName,
            comment,
        };
    },
    convertDate(date) {
        const dateString = moment(date).format('DD/MM/YYYY');
        return dateString;
    },
    getStatus(status) {
        return ROLE_STATUS[status];
    },
});

export default Role;
